import script from "./ChatFriendRequestMessage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatFriendRequestMessage.vue?vue&type=script&setup=true&lang=ts"

import "./ChatFriendRequestMessage.vue?vue&type=style&index=0&id=e54c3ce2&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e54c3ce2"]])

export default __exports__